import React, { useEffect, useState } from "react";
import Back from "assets/images/svg/back_blue.svg";
import { useNavigate, useSearchParams } from "react-router-dom";


import { useModal } from "hooks";
import PaymentApproved from "./component/paymentApproved";
import PaymentFailed from "./component/paymentFailed";

import { Button, Form } from "components/form";
import { useTranslation } from "react-i18next";

const FawryCard = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [showPaymentApproved, openPaymentApproved, paypalClose, closePaypalWithRoute] = useModal(false);
  const [showPaymentFail, openPaymentFail, closePaymentFail,closeWithRoute] = useModal(false);
  const { t } = useTranslation("browse-apps");

  let appPayDetails = JSON.parse(localStorage.getItem("appPayDetails"));

  const status = searchParams.get("status");
  
useEffect(()=>{
  if(status === '1'){
    openPaymentApproved()
  }else{
    openPaymentFail()
  }
},[])



  return (
    <div className="payment-details">
      <div className="header">
        <Button className="btn-back" onClick={() => navigate(-1)}>
          <img className="back" src={Back} alt="back" />
        </Button>
        <h1 className="title"> {t("paymentDetails.mainTitle")}</h1>
      </div>
      <hr className="hr" />
      <div className="row">
        <div className="col-xl-5 col-lg-8 col-md-12">
          {/* <Button className="btn-blue" onClick={finishPay}>
            CheckOut
          </Button> */}
        </div>
      </div>
      <PaymentFailed show={showPaymentFail} onHide={() => closeWithRoute("/browse-apps")} />
      <PaymentApproved show={showPaymentApproved} onHide={() => closePaypalWithRoute("/my-products")} data={appPayDetails} />
    </div>
  );
};

export default FawryCard;
